import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import NavBar from './components/navbar';
import Footer from './components/footer';
import NotFound from './components/notfound';
import Home from './components/Home/home-view';
import About from './components/About/about-view';
//import Experience from './components/Experience/experience-view';
import Projects from './components/Projects/projects-view';
import Resume from './components/Resume/resume-view';
import Contact from './components/Contact/contact-view'

import MediaBias from './components/Projects/Media-Bias/media-bias-view';
import ToDo from './components/Projects/To-Do/to-do-view';
import StardewQuiz from './components/Projects/Stardew-Quiz/stardew-quiz-view';
import MTAOpenData from './components/Projects/MTA-Open-Data/mta-open-data-view'
import AStar from './components/Projects/A-Star/a-star-view'

import Timer from './components/Projects/Timer/timer-view'

import ClarityNavbar from './components/Clarity/clarity-navbar';
import ClarityFooter from './components/Clarity/clarity-footer';
import Clarity from './components/Clarity/clarity-view';
import ClarityExamples from './components/Clarity/example-view';
import ClarityFeatures from './components/Clarity/feature-view';
import ClarityFAQ from './components/Clarity/faq-view';


const show = (Component) => {
  return(
    <>
      <NavBar/>
      <Component/>
      <Footer/>
    </>
  )
}

const clarityTab = (component) => {
  return (
    <>
      <ClarityNavbar />
      {component}
      <ClarityFooter />
    </>
  )
}

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); 

  return null; 
};

function App() {

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/clarity" replace />} />
        <Route path="/home" element={show(Home)} />
        <Route path="/about" element={show(About)} />
        <Route path="/projects" element={show(Projects)} />
          <Route path="/projects/media-bias" element={show(MediaBias)} />
          <Route path="/projects/todo" element={<ToDo/>}/>
          <Route path="/projects/mta-open-data" element={<MTAOpenData/>}/>
          <Route path="/projects/a-star" element={<AStar/>}/>
          <Route path="/projects/timer" element={<Timer/>}/>
        <Route path="/personality-quiz/stardew" element={<StardewQuiz />} />
        <Route path="/resume" element={show(Resume)} />
        <Route path="/clarity" element={clarityTab(<Clarity/>)}/>
          <Route path="/clarity/features" element={clarityTab(<ClarityFeatures />)} />
          <Route path="/clarity/examples" element={clarityTab(<ClarityExamples />)} />
          <Route path="clarity/faq" element={clarityTab(<ClarityFAQ />)} />
        <Route path="/contact" element={show(Contact)} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;